import {
  getSegmentsApiV1BenchmarkSegmentsGet,
  getDataApiV1BenchmarkDataPost,
  getAvailableMonthsApiV1BenchmarkAvailableMonthsGet,
  getHistoricalDataApiV1BenchmarkHistoricalDataPost,
  getParticipationReportApiV1BenchmarkParticipationReportPost,
} from "@/backend-sdk/client/sdk.gen";
import type {
  BenchmarkDataResponse,
  BenchmarkMetrics,
  RangeValue,
  RankingItem,
  BenchmarkAvailableMonthsResponse,
  BenchmarkParticipationReportResponse,
} from "@/backend-sdk/client/types.gen";

function activeCustomerUuid(): string | undefined {
  return localStorage.getItem("active_customer_uuid") ?? undefined;
}

export type {
  BenchmarkDataResponse,
  BenchmarkMetrics,
  RangeValue,
  RankingItem,
  BenchmarkAvailableMonthsResponse,
  BenchmarkParticipationReportResponse,
};

export function getBenchmarkRanges(
  data: BenchmarkDataResponse,
): Record<string, RangeValue> {
  return data.ranges ?? {};
}

export async function fetchSegments(scope: string): Promise<string[]> {
  const customerUuid = activeCustomerUuid();
  const { data } = await getSegmentsApiV1BenchmarkSegmentsGet({
    query: {
      scope,
      customer_uuid: customerUuid ?? "",
    },
  });
  if (!data?.ok) return [];
  return data.segmentos ?? [];
}

export interface FetchDataParams {
  scope: string;
  segment: string;
  window: string;
  hideMyAccount?: boolean;
}

export async function fetchBenchmarkData(
  params: FetchDataParams,
): Promise<BenchmarkDataResponse | null> {
  const customerUuid = activeCustomerUuid();
  const { data, error } = await getDataApiV1BenchmarkDataPost({
    query: {
      customer_uuid: customerUuid ?? "",
      scope: params.scope,
      segment: params.segment === "__todos__" ? null : params.segment,
      window: params.window,
      hide_my_account: params.hideMyAccount ?? false,
    },
  });
  if (error || !data?.ok) {
    console.error("[Benchmark] fetchBenchmarkData error:", error);
    return null;
  }
  return data;
}

export async function fetchAvailableMonths(
  scope: string,
): Promise<BenchmarkAvailableMonthsResponse | null> {
  const customerUuid = activeCustomerUuid();
  const { data, error } =
    await getAvailableMonthsApiV1BenchmarkAvailableMonthsGet({
      query: { scope, customer_uuid: customerUuid ?? "" },
    });
  if (error || !data?.ok) {
    console.error("[Benchmark] fetchAvailableMonths error:", error);
    return null;
  }
  return data;
}

export interface FetchHistoricalDataParams {
  scope: string;
  yearMonth: string;
  granularity: string;
  segment: string;
  hideMyAccount?: boolean;
}

export async function fetchHistoricalData(
  params: FetchHistoricalDataParams,
): Promise<BenchmarkDataResponse | null> {
  const customerUuid = activeCustomerUuid();
  const { data, error } =
    await getHistoricalDataApiV1BenchmarkHistoricalDataPost({
      query: {
        customer_uuid: customerUuid ?? "",
        scope: params.scope,
        year_month: params.yearMonth,
        granularity: params.granularity,
        segment: params.segment === "__todos__" ? null : params.segment,
        hide_my_account: params.hideMyAccount ?? false,
      },
    });
  if (error || !data?.ok) {
    console.error("[Benchmark] fetchHistoricalData error:", error);
    return null;
  }
  return data;
}

export async function fetchParticipationReport(
  window?: string,
): Promise<BenchmarkParticipationReportResponse | null> {
  const customerUuid = activeCustomerUuid();
  const { data, error } =
    await getParticipationReportApiV1BenchmarkParticipationReportPost({
      query: { customer_uuid: customerUuid ?? "", window: window ?? "7d" },
    });
  if (error || !data?.ok) {
    console.error("[Benchmark] fetchParticipationReport error:", error);
    return null;
  }
  return data;
}
